import { useState } from "react";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/track";
import { useSiteSettings, eur } from "@/lib/siteSettings";
import CheckoutDialog from "./CheckoutDialog";
import { S } from "./summaryCopy";

// Mobile only: on a phone the offer is otherwise many screens below the first
// finding. Shown by SummaryReport after the first block is read and hidden
// while the offer itself is on screen. Excluded from print.
// With payments live the button opens the checkout dialog directly; otherwise
// it scrolls to the offer block (request flow).
export default function StickyOfferBar({ token, lang, show }) {
  const settings = useSiteSettings();
  const paymentsLive = settings.payments_live === true;
  const [open, setOpen] = useState(false);
  const go = () => {
    trackEvent(token, "cta_clicked", { placement: "sticky" });
    if (paymentsLive) {
      setOpen(true);
      return;
    }
    document.getElementById("angebot")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <>
      {show && (
        <div
          className="fixed inset-x-0 bottom-0 z-20 border-t bg-background/95 p-3 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur sm:hidden print:hidden"
          data-testid="sticky-offer-bar"
        >
          <Button className="w-full" onClick={go} aria-label={S[lang].offer.ctaStickyLabel}>{S[lang].offer.ctaSticky(eur(settings.report_price_eur, lang))}</Button>
        </div>
      )}
      {paymentsLive && <CheckoutDialog open={open} onOpenChange={setOpen} token={token} product="report" lang={lang} />}
    </>
  );
}
